import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardText,
  Col,
  Container,
} from 'reactstrap';
import Breadcrumbs from '../../../components/Common/Breadcrumb';

import LoadingSpiner from '../../components/LoadingSpiner';
import {
  capitalizeWords,
  formatPhoneNumber,
  formatPrice,
} from '../../components/capitalizeFunction';
import { useOneCommande } from '../../../Api/queriesCommande';
import { useParams } from 'react-router-dom';
import React from 'react';
import html2pdf from 'html2pdf.js';

import PaiementsHistorique from '../PaiementsHistorique/PaiementsHistorique';
import LivraisonHistorique from '../Livraison/ListeLivraisonHistorique';

import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';
import { companyName } from '../../CompanyInfo/CompanyInfo';
import FactureHeader from './FactureHeader';
import LogoFiligran from './LogoFiligran';
import BackButton from '../../components/BackButton';

export default function Facture() {
  const { id } = useParams();
  const { data: selectedCommande, isLoading, error } = useOneCommande(id);
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef });

  // ------------------------------------------
  // ------------------------------------------
  // Export En PDF
  // ------------------------------------------
  // ------------------------------------------
  const exportPDFFacture = () => {
    const element = document.getElementById('facture');
    const opt = {
      filename: 'facture.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .save()
      .catch((err) => console.error('Error generating PDF:', err));
  };

  const selectedPaieCommande = selectedCommande?.paiementCommande;

  const selectedCommData = selectedCommande?.commandeData;

  const subTotal =
    selectedPaieCommande?.totalAmount || selectedCommData?.totalAmount;
  const total = subTotal + selectedCommData?.sheepingFee;

  const totalPaye = selectedPaieCommande?.totalPaye || 0;

  const reliquat = total - totalPaye;

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumbs title='Commande' breadcrumbItem='Factures' />

          <Col className='col-sm-auto mb-3'>
            <div className='d-flex gap-4  justify-content-center align-items-center'>
              <BackButton />
              <Button
                color='info'
                className='add-btn'
                id='create-btn'
                onClick={reactToPrintFn}
              >
                <i className='fas fa-print align-center me-1'></i> Imprimer
              </Button>

              <Button color='danger' onClick={exportPDFFacture}>
                <i className='fas fa-paper-plane  me-1 '></i>
                Télécharger en PDF
              </Button>
            </div>
          </Col>

          {error && (
            <div className='text-danger text-center'>
              Erreur de chargement des données
            </div>
          )}
          {isLoading && <LoadingSpiner />}

          <div ref={contentRef} id='facture'>
            {!error && !isLoading && (
              <Card
                className='d-flex justify-content-center border border-info'
                style={{
                  boxShadow: '0px 0px 10px rgba(100, 169, 238, 0.5)',
                  borderRadius: '15px',
                  width: '560px',
                  margin: '5px auto',
                  position: 'relative',
                }}
              >
                <CardBody>
                  <FactureHeader />
                  {selectedCommData?.statut === 'livré' && reliquat === 0 && (
                    <div
                      style={{
                        position: 'absolute',
                        left: '20px',
                        transform: 'rotate(-45deg)',
                        opacity: '0.5',
                        border: '1px dashed #022f72',
                        color: ' #022f72',
                        fontSize: ' 34px',
                        fontweight: 'bold',
                        width: '100%',
                        textAlign: 'cente',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <p> Payée et Livrée</p>
                    </div>
                  )}
                  {selectedCommData?.statut === 'livré' &&
                    totalPaye < total && (
                      <div
                        style={{
                          position: 'absolute',
                          left: '20px',
                          transform: 'rotate(-45deg)',
                          opacity: '0.5',
                          border: '1px dashed #022f72',
                          color: ' #022f72',
                          fontSize: ' 34px',
                          fontweight: 'bold',
                          width: '100%',
                          textAlign: 'cente',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <p> Livrée Non Payée</p>
                      </div>
                    )}

                  {selectedCommData?.statut === 'en attente' &&
                    (!totalPaye || totalPaye < total) && (
                      <div
                        style={{
                          position: 'absolute',
                          left: '20px',
                          transform: 'rotate(-45deg)',
                          opacity: '0.5',
                          border: '1px dashed #720202',
                          color: ' #720202',
                          fontSize: ' 34px',
                          fontweight: 'bold',
                          width: '100%',
                          textAlign: 'cente',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <p>Non Payée Non Livrée</p>
                      </div>
                    )}
                  {selectedCommData?.statut === 'en attente' &&
                    reliquat === 0 && (
                      <div
                        style={{
                          position: 'absolute',
                          left: '20px',
                          transform: 'rotate(-45deg)',
                          opacity: '0.5',
                          border: '1px dashed #720202',
                          color: ' #720202',
                          fontSize: ' 34px',
                          fontweight: 'bold',
                          width: '100%',
                          textAlign: 'cente',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <p> Payée Non Livrée</p>
                      </div>
                    )}
                  {selectedCommData?.statut === 'en cours' &&
                    totalPaye === total && (
                      <div
                        style={{
                          position: 'absolute',
                          left: '20px',
                          transform: 'rotate(-45deg)',
                          opacity: '0.5',
                          border: '1px dashed #720202',
                          color: ' #720202',
                          fontSize: ' 34px',
                          fontweight: 'bold',
                          width: '100%',
                          textAlign: 'cente',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <p> Payée Livraison en cours</p>
                      </div>
                    )}
                  {selectedCommData?.statut === 'en cours' &&
                    (!totalPaye || totalPaye < total) && (
                      <div
                        style={{
                          position: 'absolute',
                          left: '20px',
                          transform: 'rotate(-45deg)',
                          opacity: '0.5',
                          border: '1px dashed #720202',
                          color: ' #720202',
                          fontSize: ' 34px',
                          fontweight: 'bold',
                          width: '100%',
                          textAlign: 'cente',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <p>Non Payée Livraison en cours</p>
                      </div>
                    )}

                  <div className=' my-2 px-2 '>
                    <div className='d-flex justify-content-between align-item-center mt-2'>
                      <CardText>
                        <strong>Facture N°: </strong>
                        <span className='text-danger'>
                          {formatPrice(
                            selectedCommande?.commandeData?.commandeId
                          )}{' '}
                        </span>
                      </CardText>
                      <CardText>
                        <strong> Date:</strong>{' '}
                        {new Date(
                          selectedCommande?.commandeData?.commandeDate
                        ).toLocaleDateString()}
                      </CardText>
                    </div>

                    {/* Infos Client */}
                    <div className='d-flex justify-content-between align-item-center  '>
                      <CardText>
                        <strong>Client: </strong>
                        {capitalizeWords(selectedCommData?.fullName)}{' '}
                      </CardText>
                      <CardText>
                        <strong>Tél: </strong>
                        {formatPhoneNumber(selectedCommData?.phoneNumber) ||
                          '------'}
                      </CardText>
                    </div>
                    <CardText className='text-start'>
                      <strong>Adresse : </strong>
                      {capitalizeWords(selectedCommData?.adresse)}
                    </CardText>
                  </div>
                  {/* Bordure Séparateur */}
                  {/* Logo en Filigrant */}
                  <LogoFiligran />
                  <div className='my-2 p-2'>
                    <table className='table align-middle table-nowrap table-hover table-bordered border-2 border-double border-info text-center'>
                      <thead>
                        <tr>
                          <th>Qté</th>
                          <th>Désignations</th>
                          <th>P.U</th>
                          <th>Montant</th>
                        </tr>
                      </thead>

                      <tbody>
                        {selectedCommData?.items?.map((article) => (
                          <tr key={article?._id}>
                            <td>{article?.quantity} </td>
                            <td className='text-wrap'>
                              {capitalizeWords(article?.produit?.name)}{' '}
                            </td>
                            <td>{formatPrice(article?.customerPrice)} F </td>
                            <td>
                              {formatPrice(
                                article?.customerPrice * article?.quantity
                              )}
                              {' F'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <CardFooter>
                    <div className='p-1'>
                      <div
                        className='d-flex
                  justify-content-between align-item-center'
                      >
                        <div>
                          {selectedCommData?.sheepingFee > 0 && (
                            <div>
                              <CardText className={'text-center'}>
                                Montant Facture:{' '}
                                <strong style={{ fontSize: '14px' }}>
                                  {formatPrice(subTotal)} F
                                </strong>
                              </CardText>
                              <CardText className={'text-center'}>
                                Frais de Livraison:{' '}
                                <strong style={{ fontSize: '14px' }}>
                                  {formatPrice(selectedCommData?.sheepingFee)} F
                                </strong>
                              </CardText>
                            </div>
                          )}
                          <CardText className={'text-center'}>
                            Total:{' '}
                            <strong style={{ fontSize: '14px' }}>
                              {formatPrice(total)} F
                            </strong>
                          </CardText>
                        </div>

                        <div>
                          <CardText className='text-center '>
                            Payée:
                            <strong style={{ fontSize: '14px' }}>
                              {formatPrice(totalPaye)} F
                            </strong>
                          </CardText>
                          <CardText className='text-center '>
                            Reliquat:
                            <strong style={{ fontSize: '14px' }}>
                              {formatPrice(reliquat)} F
                            </strong>
                          </CardText>
                        </div>
                      </div>
                    </div>
                    <p className=' mt-2 text-info'>
                      Arrêté la présente facture à la somme de:{' '}
                      <strong style={{ fontSize: '14px' }}>
                        {formatPrice(total)} F
                      </strong>
                    </p>
                    <p className='font-size-10 text-center'>
                      Merci pour votre confiance et votre achat chez{' '}
                      {companyName}. Nous espérons vous revoir bientôt!
                    </p>
                  </CardFooter>
                </CardBody>
              </Card>
            )}
          </div>
          {/* Historique de Paiement */}
          <PaiementsHistorique
            id={id}
            reliqua={reliquat}
            boutique={selectedCommande?.commandeData?.user?.boutique}
          />
          {/* Historique de Paiement */}

          {/* Historique de Lvraison */}
          <LivraisonHistorique id={id} commandeItems={selectedCommData} />
          {/* Historique de Lvraison */}
        </Container>
      </div>
    </React.Fragment>
  );
}
